<template>
  <div class="my-20 single-post flex flex-row justify-center">
    <blockquote class="twitter-tweet"><a :href="postLink"></a></blockquote>
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'SingleSocialMediaPost - Twitter',
  props: {
    postLink: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.addTwitterScript();
  },
  methods: {
    addTwitterScript() {
      if (!document.querySelector('[data-post="twitter"]')) {
        const script = document.createElement('script');
        script.setAttribute('src', 'https://platform.twitter.com/widgets.js');
        script.setAttribute('async', '');
        script.setAttribute('charset', 'utf-8');
        script.setAttribute('data-post', 'twitter');
        document.head.appendChild(script);
      }
    },
  },
});
</script>

<style scoped>
@reference "~/assets/css/main.css";
.single-post {
  @apply px-2;
}
@media screen and (min-width: 350px) {
  .single-post {
    @apply container px-0;
  }
}
</style>
